import type contentEn from "./content.en";

const contentFr: Record<keyof typeof contentEn, string> = {
  "admin.content.AdminAnnouncements.0": "Erreur de chargement",
  "admin.content.AdminAnnouncements.1": "Titre et contenu requis",
  "admin.content.AdminAnnouncements.2": "Annonce mise à jour",
  "admin.content.AdminAnnouncements.3": "Annonce créée",
  "admin.content.AdminAnnouncements.4": "Annonce désactivée",
  "admin.content.AdminAnnouncements.5": "Annonce activée",
  "admin.content.AdminAnnouncements.6": "Annonce supprimée",
  "admin.content.AdminAnnouncements.7": "Annonces aux membres",
  "admin.content.AdminAnnouncements.8": "Bandeau affiché dans l'espace membre",
  "admin.content.AdminAnnouncements.9": "Nouvelle annonce",
  "admin.content.AdminAnnouncements.10": "Chargement...",
  "admin.content.AdminAnnouncements.11": "Aucune annonce pour le moment",
  "admin.content.AdminAnnouncements.12": "Créer la première annonce",
  "admin.content.AdminAnnouncements.13": "Active",
  "admin.content.AdminAnnouncements.14": "Créée le",
  "admin.content.AdminAnnouncements.15": "Modifier l'annonce",
  "admin.content.AdminAnnouncements.16": "Nouvelle annonce",
  "admin.content.AdminAnnouncements.17": "Affichée en bandeau en haut de l'espace membre. Un seul bandeau actif à la fois.",
  "admin.content.AdminAnnouncements.18": "Titre",
  "admin.content.AdminAnnouncements.19": "Contenu",
  "admin.content.AdminAnnouncements.20": "Texte brut. Les retours à la ligne sont conservés.",
  "admin.content.AdminAnnouncements.21": "Style",
  "admin.content.AdminAnnouncements.22": "Info (bleu)",
  "admin.content.AdminAnnouncements.23": "Succès (vert)",
  "admin.content.AdminAnnouncements.24": "Attention (orange)",
  "admin.content.AdminAnnouncements.25": "Activer immédiatement",
  "admin.content.AdminAnnouncements.26": "Désactivera les autres annonces actives.",
  "admin.content.AdminAnnouncements.27": "Annuler",
  "admin.content.AdminAnnouncements.28": "Enregistrer",
  "admin.content.AdminAnnouncements.29": "Créer",
  "admin.content.AdminAnnouncements.30": "Supprimer cette annonce ?",
  "admin.content.AdminAnnouncements.31": "Cette action est irréversible.",
  "admin.content.AdminAnnouncements.32": "Annuler",
  "admin.content.AdminAnnouncements.33": "Supprimer",
  "admin.content.AdminResources.0": "Titre et catégorie requis",
  "admin.content.AdminResources.1": "Ressource mise à jour",
  "admin.content.AdminResources.2": "Ressource créée",
  "admin.content.AdminResources.3": "Nom de catégorie requis",
  "admin.content.AdminResources.4": "Catégorie mise à jour",
  "admin.content.AdminResources.5": "Catégorie créée",
  "admin.content.AdminResources.6": "Supprimer cette ressource ?",
  "admin.content.AdminResources.7": "Ressource supprimée",
  "admin.content.AdminResources.8": "Supprimer cette catégorie ? Les ressources associées seront également supprimées.",
  "admin.content.AdminResources.9": "Catégorie supprimée",
  "admin.content.AdminResources.10": "Gestion des ressources",
  "admin.content.AdminResources.11": "Ressources",
  "admin.content.AdminResources.12": "Catégories",
  "admin.content.AdminResources.13": "Toutes les catégories",
  "admin.content.AdminResources.14": "Toutes les catégories",
  "admin.content.AdminResources.15": "Nouvelle ressource",
  "admin.content.AdminResources.16": "Modifier la ressource",
  "admin.content.AdminResources.17": "Nouvelle ressource",
  "admin.content.AdminResources.18": "Créez ou modifiez une ressource pour les membres",
  "admin.content.AdminResources.19": "Titre *",
  "admin.content.AdminResources.20": "Catégorie *",
  "admin.content.AdminResources.21": "Choisir une catégorie",
  "admin.content.AdminResources.22": "Slug (laisser vide pour génération auto)",
  "admin.content.AdminResources.23": "Extrait (résumé court)",
  "admin.content.AdminResources.24": "Contenu (Markdown) *",
  "admin.content.AdminResources.25": "Publié",
  "admin.content.AdminResources.26": "Annuler",
  "admin.content.AdminResources.27": "Mettre à jour",
  "admin.content.AdminResources.28": "Créer",
  "admin.content.AdminResources.29": "Aucune ressource",
  "admin.content.AdminResources.30": "Brouillon",
  "admin.content.AdminResources.33": "Voir la ressource",
  "admin.content.AdminResources.34": "Nouvelle catégorie",
  "admin.content.AdminResources.35": "Modifier la catégorie",
  "admin.content.AdminResources.36": "Nouvelle catégorie",
  "admin.content.AdminResources.37": "Nom *",
  "admin.content.AdminResources.38": "Slug",
  "admin.content.AdminResources.39": "Icône (lucide-react)",
  "admin.content.AdminResources.40": "file-text, mail, shield...",
  "admin.content.AdminResources.41": "Description",
  "admin.content.AdminResources.42": "Ordre d'affichage",
  "admin.content.AdminResources.43": "Annuler",
  "admin.content.AdminResources.44": "Mettre à jour",
  "admin.content.AdminResources.45": "Créer",
  "admin.content.AdminResources.46": "Aucune catégorie",
  "admin.content.AdminResources.47": "• Ordre:",
  "admin.content.AdminSuggestions.0": "Fonctionnalité",
  "admin.content.AdminSuggestions.1": "Amélioration",
  "admin.content.AdminSuggestions.2": "En cours",
  "admin.content.AdminSuggestions.3": "Acceptée",
  "admin.content.AdminSuggestions.4": "Implémentée",
  "admin.content.AdminSuggestions.5": "Refusée",
  "admin.content.AdminSuggestions.6": "Erreur de chargement",
  "admin.content.AdminSuggestions.8": "Nouvelle suggestion reçue",
  "admin.content.AdminSuggestions.9": "Suggestion mise à jour",
  "admin.content.AdminSuggestions.10": "Erreur lors de la mise à jour",
  "admin.content.AdminSuggestions.11": "Supprimer définitivement cette suggestion ?",
  "admin.content.AdminSuggestions.12": "Erreur de suppression",
  "admin.content.AdminSuggestions.13": "Suggestion supprimée",
  "admin.content.AdminSuggestions.14": "Suggestions membres - Admin",
  "admin.content.AdminSuggestions.15": "Gestion des suggestions envoyées par les membres",
  "admin.content.AdminSuggestions.16": "Suggestions des membres",
  "admin.content.AdminSuggestions.17": "Statut",
  "admin.content.AdminSuggestions.18": "Tous",
  "admin.content.AdminSuggestions.19": "Catégorie",
  "admin.content.AdminSuggestions.20": "Toutes",
  "admin.content.AdminSuggestions.21": "Aucune suggestion ne correspond aux filtres.",
  "admin.content.AdminSuggestions.26": "Statut",
  "admin.content.AdminSuggestions.27": "Réponse au membre (visible par lui)",
  "admin.content.AdminSuggestions.28": "Votre réponse sera affichée sur la page du membre.",
  "admin.content.AdminSuggestions.30": "Supprimer",
  "admin.content.AdminSuggestions.31": "Annuler",
  "admin.content.AdminSuggestions.32": "Enregistrer",
  "admin.content.AdminPostEditor.0": "Le titre doit contenir au moins 3 caractères",
  "admin.content.AdminPostEditor.1": "Le titre est trop long",
  "admin.content.AdminPostEditor.2": "Le slug doit contenir au moins 3 caractères",
  "admin.content.AdminPostEditor.3": "Le slug est trop long",
  "admin.content.AdminPostEditor.4": "Le slug ne peut contenir que des lettres minuscules, chiffres et tirets",
  "admin.content.AdminPostEditor.5": "Le résumé est trop long",
  "admin.content.AdminPostEditor.6": "Le contenu doit contenir au moins 10 caractères",
  "admin.content.AdminPostEditor.7": "Le nom de l'auteur doit contenir au moins 2 caractères",
  "admin.content.AdminPostEditor.8": "URL invalide",
  "admin.content.AdminPostEditor.9": "Article introuvable",
  "admin.content.AdminPostEditor.10": "Date de publication invalide",
  "admin.content.AdminPostEditor.11": "Ce slug existe déjà",
  "admin.content.AdminPostEditor.12": "Erreur lors de la création",
  "admin.content.AdminPostEditor.13": "Article créé avec succès",
  "admin.content.AdminPostEditor.14": "Erreur lors de la mise à jour",
  "admin.content.AdminPostEditor.15": "Article mis à jour avec succès",
  "admin.content.AdminPostEditor.16": "Chargement...",
  "admin.content.AdminPostEditor.17": "Nouvel article",
  "admin.content.AdminPostEditor.18": "Modifier l'article",
  "admin.content.AdminPostEditor.19": "Retour",
  "admin.content.AdminPostEditor.20": "Nouvel article",
  "admin.content.AdminPostEditor.21": "Modifier l'article",
  "admin.content.AdminPostEditor.22": "Titre *",
  "admin.content.AdminPostEditor.23": "Slug (URL) *",
  "admin.content.AdminPostEditor.24": "Utilisé dans l'URL : /blog/",
  "admin.content.AdminPostEditor.25": "Auteur *",
  "admin.content.AdminPostEditor.26": "Date de publication *",
  "admin.content.AdminPostEditor.27": "Date future = article planifié, invisible jusqu'à cette date.",
  "admin.content.AdminPostEditor.28": "URL de l'image de couverture",
  "admin.content.AdminPostEditor.29": "Génération de la miniature…",
  "admin.content.AdminPostEditor.30": "✓ Miniature 480px générée automatiquement.",
  "admin.content.AdminPostEditor.31": "Miniature non générée (image inaccessible en CORS) — l'image pleine taille sera utilisée en secours.",
  "admin.content.AdminPostEditor.32": "Une miniature 480px WebP sera générée automatiquement.",
  "admin.content.AdminPostEditor.33": "Résumé",
  "admin.content.AdminPostEditor.34": "Courte description de l'article (optionnel)",
  "admin.content.AdminPostEditor.35": "Contenu * (HTML supporté)",
  "admin.content.AdminPostEditor.36": "<p>Votre contenu ici...</p>",
  "admin.content.AdminPostEditor.37": "Vous pouvez utiliser du HTML pour formater votre contenu",
  "admin.content.AdminPostEditor.38": "Enregistrer",
  "admin.content.AdminPostEditor.39": "Annuler",
  "admin.content.AdminSettings.2": "Erreur lors du chargement des paramètres",
  "admin.content.AdminSettings.3": "Drive partagé activé",
  "admin.content.AdminSettings.4": "Drive partagé désactivé",
  "admin.content.AdminSettings.5": "Erreur lors de la mise à jour",
  "admin.content.AdminSettings.6": "URL du drive enregistrée",
  "admin.content.AdminSettings.7": "Erreur lors de l'enregistrement",
  "admin.content.AdminSettings.8": "Protection par mot de passe activée",
  "admin.content.AdminSettings.9": "Protection par mot de passe désactivée",
  "admin.content.AdminSettings.11": "Erreur lors de la mise à jour des paramètres",
  "admin.content.AdminSettings.12": "Compteur d'inscriptions affiché",
  "admin.content.AdminSettings.13": "Compteur d'inscriptions masqué",
  "admin.content.AdminSettings.15": "Erreur lors de la mise à jour des paramètres",
  "admin.content.AdminSettings.16": "Tracking des visiteurs activé",
  "admin.content.AdminSettings.17": "Tracking des visiteurs désactivé",
  "admin.content.AdminSettings.19": "Erreur lors de la mise à jour des paramètres",
  "admin.content.AdminSettings.20": "Mode maintenance activé - les visiteurs verront une page de maintenance",
  "admin.content.AdminSettings.21": "Mode maintenance désactivé - le site est de nouveau accessible",
  "admin.content.AdminSettings.23": "Erreur lors de la mise à jour des paramètres",
  "admin.content.AdminSettings.24": "Chargement...",
  "admin.content.AdminSettings.25": "Paramètres du site",
  "admin.content.AdminSettings.27": "Mode Maintenance",
  "admin.content.AdminSettings.28": "Activez le mode maintenance pour afficher une page temporaire aux visiteurs pendant vos modifications",
  "admin.content.AdminSettings.29": "Activer le mode maintenance",
  "admin.content.AdminSettings.30": "Les visiteurs verront une page de maintenance. Les administrateurs connectés peuvent toujours accéder au site.",
  "admin.content.AdminSettings.31": "Le mode maintenance est actuellement actif. Les visiteurs non-connectés ne peuvent pas accéder au site.",
  "admin.content.AdminSettings.32": "Sécurité",
  "admin.content.AdminSettings.33": "Gérez les paramètres de sécurité de votre site",
  "admin.content.AdminSettings.34": "Protection par mot de passe",
  "admin.content.AdminSettings.35": "Lorsque activée, les visiteurs doivent entrer un mot de passe pour accéder au site",
  "admin.content.AdminSettings.36": "Afficher le compteur d'inscriptions",
  "admin.content.AdminSettings.37": "Affiche le nombre de conseillers inscrits sur la page d'accueil",
  "admin.content.AdminSettings.38": "Activer le tracking des visiteurs",
  "admin.content.AdminSettings.39": "Enregistre les visites dans la section \"Visiteurs\" de l'admin",
  "admin.content.AdminSettings.40": "Drive partagé membres",
  "admin.content.AdminSettings.41": "Configurez un dossier Google Drive partagé accessible depuis l'espace membre (page",
  "admin.content.AdminSettings.43": "). Les membres peuvent y consulter et déposer des fichiers.",
  "admin.content.AdminSettings.44": "Activer le drive partagé",
  "admin.content.AdminSettings.45": "Lorsque désactivé, la page affiche un message « Bientôt disponible » aux membres.",
  "admin.content.AdminSettings.46": "URL du dossier Google Drive",
  "admin.content.AdminSettings.47": "Collez l'URL du dossier partagé (format",
  "admin.content.AdminSettings.49": "). Le dossier doit être partagé en mode « Toute personne avec le lien » (lecteur ou éditeur).",
  "admin.content.AdminSettings.50": "Enregistrer",
  "admin.content.AdminSettings.51": "URL actuelle :",
  "admin.content.AdminSettings.53": "Déconnecter tous les membres",
  "admin.content.AdminSettings.54": "Termine toutes les sessions actives. Chaque membre devra se reconnecter au prochain accès. Votre session admin est préservée.",
  "admin.content.AdminSettings.55": "Confirmer la déconnexion de tous les membres ?",
  "admin.content.AdminSettings.56": "Session admin expirée. Veuillez vous reconnecter.",
  "admin.content.AdminSettings.57": "Erreur lors de la déconnexion globale",
  "admin.content.AdminSettings.58": "Forcer la déconnexion de tous les membres",
  "admin.content.suggestions.Resource": "Ressource",
  "admin.content.suggestions.Bug": "Bug",
  "admin.content.suggestions.Other": "Autre",
  "admin.content.suggestions.New": "Nouveau",
  "admin.content.suggestions.Member": "Membre",
  "admin.content.scheduled": "📅 Article planifié — publié automatiquement le {date}.",
  "admin.content.signoutSuccess": "Déconnexion forcée envoyée ({count} membre(s) ciblé(s))",
  "admin.content.variant.info": "info",
  "admin.content.variant.success": "success",
  "admin.content.variant.warning": "warning",
};

export default contentFr;
